export default "__VITE_ASSET__712f5c10__"